export const DS_FORM_FIELD_ERROR_CLASSES = {
  Root: "ds-form-field-error",
  Icon: "ds-form-field-error__icon",
} as const;
